module.exports = __webpack_public_path__ + "img/13.8763fe43.webp";